/**
 * An image field can be saved with only its defaults (for example `fit: "cover"`)
 * and no uploaded file. `@sanity/image-url` throws on that object.
 */
export function sanityImageWithAsset<T extends { asset?: { _ref?: string | null } | null }>(
  source: T | null | undefined,
): T | undefined {
  if (!source?.asset?._ref) {
    return undefined;
  }

  return source;
}
